<template>
  <EdroneBadge
    v-if="typeof isAvailable === 'boolean'"
    :type="isAvailable === true ? 'success' : 'default'"
    :label="isAvailable ? trans._products.content.available : trans._products.content.unavailable"
    size="small"
  />
  <EdroneSkeletonLoader v-else class="tw:w-[6.25rem] tw:h-[1.25rem]" />
</template>

<script setup lang="ts">
import EdroneBadge from "edrone-components/EdroneBadge/EdroneBadge.vue";
import EdroneSkeletonLoader from "edrone-components/EdroneSkeletonLoader.vue";

interface Props {
  isAvailable: boolean | null;
}

defineProps<Props>();
</script>
